import script from "./loginForm.vue?vue&type=script&lang=js"
export * from "./loginForm.vue?vue&type=script&lang=js"

import "./loginForm.vue?vue&type=style&index=0&id=724b1d08&lang=css"

const __exports__ = script;

export default __exports__